/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Product Card Styled
 *
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.10.0
 */

import styled from 'styled-components';

export const ProductCardStyled = styled.div.attrs({
    className: 'product-card',
})`
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 8px;
    box-shadow: 0 2px 9px rgba(0, 0, 0, 0.15);
`;
